import { GlobeFillIcon } from '@zep-us/zus';
import { Blue500 } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { AiButton, AiButtonIcon } from './AiButtonBase';
export const AiWebsiteButton = ({
  onOpenBuildAiModal,
  isFull
}: {
  onOpenBuildAiModal: () => void;
  isFull: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <AiButton icon={<AiButtonIcon className="bg-blue-50" icon={<GlobeFillIcon size={isFull ? 'sm' : 'xs'} fill={Blue500} />} />} isBeta={true} label={t('build:build.website.button.label')} description={t('build:build.website.button.description')} size={isFull ? 'full' : 'simple'} onClick={onOpenBuildAiModal} data-sentry-element="AiButton" data-sentry-component="AiWebsiteButton" data-sentry-source-file="AiWebsiteButton.tsx" />;
};